import * as BABYLON from "@babylonjs/core";
import { PointerToDragController } from "core/map/inputs";
import { Observable } from "core/events";
import { PointerToGestureController } from "core/map/inputs/map.inputs.controller.touch";
export class TransformedPointerToDragController extends PointerToDragController {
    constructor(source) {
        super(source);
    }
    _getClientX(e) {
        return e.displayX ?? e.clientX;
    }
    _getClientY(e) {
        return e.displayY ?? e.clientY;
    }
}
export class TransformedPointerToGestureController extends PointerToGestureController {
    constructor(source) {
        super(source);
    }
    _getClientX(e) {
        return e.displayX ?? e.clientX;
    }
    _getClientY(e) {
        return e.displayY ?? e.clientY;
    }
}
export class VirtualDisplayInputsSource {
    constructor(display) {
        this._lastX = -1;
        this._lastY = -1;
        this._display = display;
        this._prePointerObserver = null;
        this._cache = BABYLON.Vector2.Zero();
        this._attach();
        this._dragController = new TransformedPointerToDragController(this);
    }
    get display() {
        return this._display;
    }
    get onTouchObservable() {
        if (!this._touchController) {
            this._touchController = new TransformedPointerToGestureController(this);
        }
        return this._touchController.onTouchObservable;
    }
    get onDragObservable() {
        return this._dragController.onDragObservable;
    }
    get onPointerOverObservable() {
        if (!this._onPointerOverObservable) {
            this._onPointerOverObservable = new Observable();
        }
        return this._onPointerOverObservable;
    }
    get onPointerEnterObservable() {
        if (!this._onPointerEnterObservable) {
            this._onPointerEnterObservable = new Observable();
        }
        return this._onPointerEnterObservable;
    }
    get onPointerOutObservable() {
        if (!this._onPointerOutObservable) {
            this._onPointerOutObservable = new Observable();
        }
        return this._onPointerOutObservable;
    }
    get onPointerLeaveObservable() {
        if (!this._onPointerLeaveObservable) {
            this._onPointerLeaveObservable = new Observable();
        }
        return this._onPointerLeaveObservable;
    }
    get onPointerMoveObservable() {
        if (!this._onPointerMoveObservable) {
            this._onPointerMoveObservable = new Observable();
        }
        return this._onPointerMoveObservable;
    }
    get onPointerDownObservable() {
        if (!this._onPointerDownObservable) {
            this._onPointerDownObservable = new Observable();
        }
        return this._onPointerDownObservable;
    }
    get onPointerUpObservable() {
        if (!this._onPointerUpObservable) {
            this._onPointerUpObservable = new Observable();
        }
        return this._onPointerUpObservable;
    }
    get onPointerCancelObservable() {
        if (!this._onPointerCancelObservable) {
            this._onPointerCancelObservable = new Observable();
        }
        return this._onPointerCancelObservable;
    }
    get onPointerGotCaptureObservable() {
        if (!this._onPointerGotCaptureObservable) {
            this._onPointerGotCaptureObservable = new Observable();
        }
        return this._onPointerGotCaptureObservable;
    }
    get onPointerLostCaptureObservable() {
        if (!this._onPointerLostCaptureObservable) {
            this._onPointerLostCaptureObservable = new Observable();
        }
        return this._onPointerLostCaptureObservable;
    }
    get onWheelObservable() {
        if (!this._onWheelObservable) {
            this._onWheelObservable = new Observable();
        }
        return this._onWheelObservable;
    }
    dispose() {
        const scene = this._getScene();
        if (scene) {
            if (this._prePointerObserver) {
                scene.onPrePointerObservable.remove(this._prePointerObserver);
            }
        }
        this._onPointerOverObservable?.clear();
        this._onPointerEnterObservable?.clear();
        this._onPointerOutObservable?.clear();
        this._onPointerLeaveObservable?.clear();
        this._onPointerMoveObservable?.clear();
        this._onPointerDownObservable?.clear();
        this._onPointerUpObservable?.clear();
        this._onPointerCancelObservable?.clear();
        this._onPointerGotCaptureObservable?.clear();
        this._onPointerLostCaptureObservable?.clear();
        this._onWheelObservable?.clear();
        this._onPointerOverObservable = undefined;
        this._onPointerEnterObservable = undefined;
        this._onPointerOutObservable = undefined;
        this._onPointerLeaveObservable = undefined;
        this._onPointerMoveObservable = undefined;
        this._onPointerDownObservable = undefined;
        this._onPointerUpObservable = undefined;
        this._onPointerCancelObservable = undefined;
        this._onPointerGotCaptureObservable = undefined;
        this._onPointerLostCaptureObservable = undefined;
        this._onWheelObservable = undefined;
    }
    _attach() {
        const scene = this._getScene();
        if (!scene) {
            return;
        }
        this._prePointerObserver = scene.onPrePointerObservable.add(this._onPrePointer.bind(this));
    }
    _onPrePointer(pi) {
        if (!this._display.node) {
            return;
        }
        const scene = this._getScene();
        if (!scene) {
            return;
        }
        if (pi.type === BABYLON.PointerEventTypes.POINTERMOVE) {
            if (this._lastX === pi.event.clientX && this._lastY === pi.event.clientY) {
                return;
            }
            this._lastX = pi.event.clientX;
            this._lastY = pi.event.clientY;
        }
        switch (pi.type) {
            case BABYLON.PointerEventTypes.POINTERMOVE: {
                this._onPointerMove(pi, scene);
                break;
            }
            case BABYLON.PointerEventTypes.POINTERUP: {
                this._onPointerUp(pi, scene);
                break;
            }
            case BABYLON.PointerEventTypes.POINTERDOWN: {
                this._onPointerDown(pi, scene);
                break;
            }
            case BABYLON.PointerEventTypes.POINTERWHEEL: {
                this._onWheel(pi);
                break;
            }
            default: {
                return;
            }
        }
    }
    _getBasePointer(pointerInfo, current) {
        const base = pointerInfo.event;
        current = current ?? this._getPickingInfos(this._getScene());
        const c = current?.getTextureCoordinates();
        if (c) {
            const pixelXY = this._display.getPixelToRef(c, this._cache);
            base.displayX = pixelXY.x;
            base.displayY = pixelXY.y;
            base.userCoordinates = c;
        }
        else {
            base.displayX = 0;
            base.displayY = 0;
        }
        return base;
    }
    _onPointerDown(pointerInfo, scene) {
        var pick = this._getPickingInfos(scene);
        var meshUnderPointer = pick ? pick.pickedMesh : scene.meshUnderPointer;
        if (meshUnderPointer !== this._display.node) {
            return;
        }
        pointerInfo.skipOnPointerObservable = true;
        if (this._onPointerDownObservable && this._onPointerDownObservable.hasObservers()) {
            const base = this._getBasePointer(pointerInfo, pick);
            this._onPointerDownObservable.notifyObservers(base, -1, this._display, this);
        }
    }
    _onPointerUp(pointerInfo, scene) {
        var pick = this._getPickingInfos(scene);
        var meshUnderPointer = pick ? pick.pickedMesh : scene.meshUnderPointer;
        if (meshUnderPointer !== this._display.node) {
            return;
        }
        pointerInfo.skipOnPointerObservable = true;
        if (this._onPointerUpObservable && this._onPointerUpObservable.hasObservers()) {
            const base = this._getBasePointer(pointerInfo, pick);
            this._onPointerUpObservable.notifyObservers(base, -1, this._display, this);
        }
    }
    _onPointerMove(pointerInfo, scene) {
        var pick = this._getPickingInfos(scene);
        var meshUnderPointer = pick ? pick.pickedMesh : scene.meshUnderPointer;
        if (this._meshUnderPointer !== meshUnderPointer) {
            if (this._meshUnderPointer) {
                if (this._meshUnderPointer === this._display.node) {
                    if (this._onPointerLeaveObservable && this._onPointerLeaveObservable.hasObservers()) {
                        const base = pointerInfo.event;
                        base.displayX = 0;
                        base.displayY = 0;
                        this._onPointerLeaveObservable.notifyObservers(base, -1, this._display, this);
                    }
                    pointerInfo.skipOnPointerObservable = true;
                }
            }
            if (meshUnderPointer) {
                if (meshUnderPointer === this._display.node) {
                    if (this._onPointerEnterObservable && this._onPointerEnterObservable.hasObservers()) {
                        const base = this._getBasePointer(pointerInfo, pick);
                        this._onPointerEnterObservable.notifyObservers(base, -1, this._display, this);
                    }
                    pointerInfo.skipOnPointerObservable = true;
                }
            }
            this._meshUnderPointer = meshUnderPointer;
            return;
        }
        if (this._meshUnderPointer != this._display.node) {
            return;
        }
        if (this._onPointerMoveObservable && this._onPointerMoveObservable.hasObservers()) {
            const base = this._getBasePointer(pointerInfo, pick);
            this._onPointerMoveObservable.notifyObservers(base, -1, this._display, this);
        }
    }
    _onWheel(pointerInfo) {
        if (this._meshUnderPointer === this._display.node) {
            pointerInfo.skipOnPointerObservable = true;
            const e = pointerInfo.event;
            if (this._onWheelObservable && this._onWheelObservable.hasObservers()) {
                this._onWheelObservable.notifyObservers(e, -1, this.display, this);
            }
        }
    }
    _getPickingInfos(scene) {
        var pickinfo = scene.pick(scene.pointerX, scene.pointerY, this._pickFilter.bind(this));
        if (pickinfo.hit) {
            return pickinfo;
        }
        return null;
    }
    _pickFilter(mesh) {
        return mesh == this._display.node;
    }
    _getScene() {
        return this._display.getScene();
    }
}
//# sourceMappingURL=display.inputs.scene.js.map